export default "__VITE_ASSET__Dth2Ya26__"